import { useQuery } from '@tanstack/react-query';
import type { MatchSuggestion } from '../../types';

export default function useProviderMatches(provider: string | null) {
  return useQuery<MatchSuggestion[]>({
    queryKey: ['connected-assets', 'matching-suggestions', { provider }],
    enabled: !!provider,
  });
}
